"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var TransparentButton_1 = __importDefault(require("./TransparentButton"));
var icons_1 = require("../icons");
var StyledTransparentButton = styled_components_1["default"](TransparentButton_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: inherit;\n  width: 20px;\n  height: 20px;\n"], ["\n  color: inherit;\n  width: 20px;\n  height: 20px;\n"])));
var CloseButton = function (props) { return (react_1["default"].createElement(StyledTransparentButton, __assign({ type: "button", ariaLabel: "close" }, props),
    react_1["default"].createElement(icons_1.Close, { size: "14px" }))); };
exports["default"] = CloseButton;
var templateObject_1;
//# sourceMappingURL=CloseButton.js.map